import React, { Component } from 'react';
import { VictoryAxis, VictoryBar, VictoryLabel } from 'victory';
import { IDateValue } from '../../lib/helpers/types';
import { QualaRange } from '../../lib/qualaRange';
import { variables } from '../utils';
import QualaChart from './QualaChart';

interface INumberChartProps {
  points: IDateValue[];
  range: QualaRange;
  small?: boolean;
  short?: boolean;
}

class NumberChart extends Component<INumberChartProps, {}> {
  public static defaultProps = {
    range: QualaRange,
    points: []
  };

  public render() {
    const { range, points, short = false } = this.props;
    const tickCount = range.timescale === 'month' ? 4 : undefined;
    return (
      <QualaChart short={short}>
        <VictoryAxis
          dependentAxis={true}
          tickFormat={t => Math.round(t)}
          tickLabelComponent={<VictoryLabel dx={12} dy={10} textAnchor="start" />}
          style={{
            axis: { stroke: 'transparent' },
            grid: { stroke: variables.black10, strokeDasharray: '0', strokeWidth: 1 }
          }}
        />
        <VictoryAxis
          crossAxis={true}
          padding={0}
          tickValues={range.ticks()}
          tickFormat={t => range.formatTick(t)}
          tickCount={tickCount}
          style={{
            axis: { stroke: variables.black10, strokeDasharray: '0', strokeWidth: 1 },
            grid: { strokeWidth: 0 }
          }}
        />

        {points && points.length > 0 && (
          <VictoryBar
            data={points}
            x="date"
            y="value"
            style={{ data: { fill: variables.blue } }}
            animate={{
              duration: 500,
              onLoad: { duration: 750 }
            }}
          />
        )}
      </QualaChart>
    );
  }
}

export default NumberChart;
